import React, { Component } from 'react';
import FormModal from 'components/shared/modal/FormModal';
import { connect } from 'react-redux';
import './ChangeOrderApprovalModal.css';
import { getCurrentUser } from 'selectors/authentication';
import {
  getCurrentWorkOrder,
  getTasks,
} from 'selectors/admin/work-orders/work-orders';
import {
  getChangeOrders,
  getSelectedChangeOrderId,
  getSelectedChangeOrderNumber,
  getShowSuccessMessage,
  getPdf,
  getShowPdfViewer,
} from 'components/admin/work-orders/details/change-orders/store/selectors';
import { getChangeOrderTasks } from 'components/admin/work-orders/details/change-order-tasks/store/selectors';
import {
  closeChangeOrderApprovalModal,
  approveChangeOrderRequest,
  closeSuccessModal,
  printChangeOrder,
  closePdfViewer,
  setShowEmailModal,
  withdrawChangeOrderRequest,
} from 'components/admin/work-orders/details/change-orders/store/actions';
import TasksReviewTable from 'components/admin/work-orders/details/proposals/TasksReviewTable';
import CostsDatesProposal from 'components/admin/work-orders/details/proposals/CostsDatesProposal';
import { ROLES, TYPES, usersUtil } from 'services/utils/users-util';
import { PermissionsUtil } from 'services/utils/permissions-util';
import {
  loadWorkOrderRequest,
  selectNavigationBar,
} from 'actions/admin/work-orders/details/details';
import { toUpperFirstLetter } from 'services/utils/text-util';
import { ProposalStatus } from 'domain/proposal-status-enum';
import {
  loadQualificationsSuccess,
  setSelectedQualificationsById,
} from 'actions/admin/work-orders/details/qualifications';
import QualificationsContainer from 'components/admin/work-orders/details/qualifications/QualificationsContainer';
import ChangeOrderEmailModal from 'components/admin/work-orders/details/change-orders/ChangeOrderEmailModal';
import Button from 'components/shared/button/Button';
import MessageModal from 'components/shared/modal/MessageModal';
import PdfViewer from 'components/shared/pdf-viewer/PdfViewer';
import ConfirmationModal from 'components/shared/modal/ConfirmationModal';
import printSvg from 'images/print.svg';
import mailSvg from 'images/mail.svg';
import moment from 'moment';
import numeral from 'numeral';

export class ChangeOrderApprovalModal extends Component {
  constructor(props) {
    super(props);

    this.selectedChangeOrder = props.changeOrders.find(
      (element) => element.id === props.selectedChangeOrderId
    );
    this.state = { showWithdrawConfirmation: false };
  }

  componentDidMount() {
    if (
      this.selectedChangeOrder.qualifications.length > 0 &&
      this.selectedChangeOrder.change_order_qualifications.length > 0
    ) {
      const selectedQualificationsById = this.selectedChangeOrder.change_order_qualifications.reduce(
        (accumulator, currentValue) => {
          accumulator[currentValue.qualification_id] = {
            id: currentValue.qualification_id,
            // value=0 because we only need the label
            option:
              currentValue.option !== null
                ? { value: 0, label: currentValue.option }
                : null,
          };
          return accumulator;
        },
        {}
      );
      this.props.dispatch(
        setSelectedQualificationsById(selectedQualificationsById)
      );
      this.props.dispatch(
        loadQualificationsSuccess(this.selectedChangeOrder.qualifications)
      );
    } else {
      this.props.dispatch(setSelectedQualificationsById({}));
      this.props.dispatch(loadQualificationsSuccess([]));
    }
  }

  handleClose = (event) => {
    event.preventDefault();
    this.props.dispatch(closeChangeOrderApprovalModal());
  };

  handleApprove = () => {
    this.props.dispatch(
      approveChangeOrderRequest(this.props.selectedChangeOrderId)
    );
  };

  handleCloseSuccessModal = () => {
    let userIsAdmin =
      usersUtil.hasRole(this.props.currentUser, ROLES.SPACKLE_ADMIN) ||
      usersUtil.hasType(this.props.currentUser, TYPES.GENERAL_CONTRACTOR);
    let userIsContractor = usersUtil.hasType(
      this.props.currentUser,
      TYPES.CONTRACTOR
    );
    let contractorUserCanSeeMoney = PermissionsUtil.contractorUserCanSeeMoney(
      this.props.currentUser
    );

    this.props.dispatch(closeSuccessModal());
    this.props.dispatch(closeChangeOrderApprovalModal());
    this.props.dispatch(
      loadWorkOrderRequest(
        this.props.currentWorkOrder.id,
        userIsAdmin,
        userIsContractor,
        contractorUserCanSeeMoney
      )
    );
    this.props.dispatch(selectNavigationBar(this.props.currentWorkOrder.id, 1));
  };

  handleChangeOrderPrint = () => {
    this.props.dispatch(printChangeOrder(this.props.selectedChangeOrderId));
  };

  handlePdfViewerClose = () => {
    this.props.dispatch(closePdfViewer());
  };

  handleChangeOrderEmail = () => {
    this.props.dispatch(setShowEmailModal(true));
  };

  handleWithdraw = () => {
    this.setState({ showWithdrawConfirmation: true });
  };

  handleWithdrawConfirmation = (response) => {
    this.setState({ showWithdrawConfirmation: false });
    if (response) {
      this.props.dispatch(
        withdrawChangeOrderRequest(this.props.selectedChangeOrderId)
      );
    }
  };

  getMaterialLeadTime(mDays) {
    if (mDays) {
      return `${numeral(mDays).value()} ${mDays > 1 ? 'days' : 'day'}`;
    }

    return 'N/A';
  }

  getCost(quote, proposalTask) {
    return (
      numeral(quote.estimate).value() +
      numeral(quote.value).value() +
      numeral(proposalTask.markup).value() +
      numeral(proposalTask.fee).value() +
      numeral(proposalTask.insurance).value()
    );
  }

  previousCost = () => {
    let prevCost = numeral(
      this.props.currentWorkOrder.approved_proposal.cost
    ).value();
    const coId = this.props.selectedChangeOrderId;
    this.props.changeOrders
      .filter((co) => ProposalStatus.APPROVED.equals(co.status))
      .forEach(function (co) {
        if (co.id !== coId && co.id < coId) {
          prevCost += numeral(co.cost).value();
        }
      });

    return prevCost;
  };

  static getWorkOrderName(workOrder) {
    return workOrder.name !== null ? `: ${workOrder.name}` : '';
  }

  render() {
    let successMessage =
      'Thank you. The Change Order approval was submitted to Spackle.';
    let titlePostfix;
    if (usersUtil.hasType(this.props.currentUser, TYPES.CLIENT)) {
      titlePostfix = moment(this.selectedChangeOrder.created_at).format('LL');
    } else {
      titlePostfix = toUpperFirstLetter(this.selectedChangeOrder.status);
    }
    const title = `Change Order (WO #${
      this.props.currentWorkOrder.number
    } ${ChangeOrderApprovalModal.getWorkOrderName(
      this.props.currentWorkOrder
    )}) - ${titlePostfix}`;

    const values = [];
    this.props.changeOrderTasks
      .sort((cot1, cot2) => cot1.task_id - cot2.task_id)
      .forEach((changeOrderTask) => {
        const changeOrderProposalTask = this.selectedChangeOrder.change_order_proposal_tasks.find(
          (copt) => copt.change_order_task_id === changeOrderTask.id
        );

        if (changeOrderProposalTask) {
          const changeOrderQuote = changeOrderTask.change_order_quote;
          const task = this.props.tasks.find(
            (t) => t.id === changeOrderTask.task_id
          );

          let value = {
            id: changeOrderTask.id,
            number: task.number,
            details: task.name !== null ? task.name : task.trade.label,
            materialLeadTime: this.getMaterialLeadTime(
              changeOrderQuote.material_lead_days
            ),
            cost: this.getCost(changeOrderQuote, changeOrderProposalTask),
          };

          values.push(value);
        }
      });

    return (
      <React.Fragment>
        <FormModal
          className="change-order-modal change-order-approval-modal"
          show={this.props.selectedChangeOrderId !== null}
          title={title}
          subTitle={
            <div className="h2">
              Spackle is pleased to submit change order #
              {this.props.selectedChangeOrderNumber} for:
            </div>
          }
          onClose={this.handleClose}
        >
          <div className="change-order-approval-container">
            <TasksReviewTable values={values} />

            <div className="costs-dates-container">
              <div className="buttons">
                <Button
                  className="button-white"
                  icon={mailSvg}
                  label="Email"
                  onClick={this.handleChangeOrderEmail}
                />
                <Button
                  className="button-white print-button"
                  icon={printSvg}
                  label="Print"
                  onClick={this.handleChangeOrderPrint}
                />
              </div>

              <CostsDatesProposal
                completionDate={{
                  value: this.selectedChangeOrder.completion_date,
                }}
                startDate={this.selectedChangeOrder.start_date}
                isChangeOrder={true}
                previousCost={this.previousCost()}
                total={numeral(this.selectedChangeOrder.cost).value()}
              />
            </div>

            <QualificationsContainer readOnly={true} />

            <div className="change-order-days-sign">
              <div className="small-regular">4130 Cahuenga Blvd, Suite 206</div>
              <div className="small-regular">Los Angeles, CA 91602</div>
              <div className="small-regular">Phone: (310) 848-3078</div>
            </div>

            {ProposalStatus.WAITING.equals(this.selectedChangeOrder.status) &&
              usersUtil.hasType(this.props.currentUser, TYPES.CLIENT) && (
                <div className="buttons-container">
                  <Button
                    className="button-orange"
                    label="Approve"
                    onClick={this.handleApprove}
                  />
                </div>
              )}

            {ProposalStatus.WAITING.equals(this.selectedChangeOrder.status) &&
              (usersUtil.hasRole(this.props.currentUser, ROLES.SPACKLE_ADMIN) ||
                usersUtil.hasType(
                  this.props.currentUser,
                  TYPES.GENERAL_CONTRACTOR
                )) && (
                <div className="buttons-container">
                  <Button
                    className="button-gray"
                    label="Withdraw"
                    onClick={this.handleWithdraw}
                  />
                  <Button
                    className="button-orange"
                    label="Approve"
                    onClick={this.handleApprove}
                  />
                </div>
              )}
          </div>
        </FormModal>

        <MessageModal
          show={this.props.showSuccessMessage}
          message={<div>{successMessage}</div>}
          onHide={this.handleCloseSuccessModal}
        />

        <PdfViewer
          content={{
            source: this.props.pdf,
            type: 'blob',
          }}
          show={this.props.showPdfViewer}
          onClose={this.handlePdfViewerClose}
        />

        <ChangeOrderEmailModal />

        <ConfirmationModal
          show={this.state.showWithdrawConfirmation}
          message="Are you sure"
          onHide={this.handleWithdrawConfirmation}
        />
      </React.Fragment>
    );
  }
}

export default connect((state) => {
  return {
    currentUser: getCurrentUser(state),
    currentWorkOrder: getCurrentWorkOrder(state),
    tasks: getTasks(state),
    changeOrders: getChangeOrders(state),
    changeOrderTasks: getChangeOrderTasks(state),
    selectedChangeOrderId: getSelectedChangeOrderId(state),
    selectedChangeOrderNumber: getSelectedChangeOrderNumber(state),
    showSuccessMessage: getShowSuccessMessage(state),
    pdf: getPdf(state),
    showPdfViewer: getShowPdfViewer(state),
  };
})(ChangeOrderApprovalModal);



// WEBPACK FOOTER //
// ./src/components/admin/work-orders/details/change-orders/ChangeOrderApprovalModal.js